import {Button} from "react-bootstrap";
import styles from "./ButtonDownload.module.css";
import DownloadSVG from "../images/download.svg";
import React from "react";

export function ButtonDownload({shopper, fullWidth, interno}) {
    return <Button id={interno? shopper.idBotonInterno: shopper.idBotonExterno}
                   className={`${styles.btnDownload} ${fullWidth?'w-100':''}`}
                   target="_blank"
                   href={shopper.pdf} download>
        <span>Descargar PDF </span>
        <span className="material-symbols-outlined material-symbols-button">download</span>
    </Button>
}
